/**
 * WordPress dependencies
 */
import domReady from '@safe-wordpress/dom-ready';

/**
 * Internal dependencies
 */
import './style.scss';
import { renderHelp } from './help';
import { initializePremiumLinks } from './premium-links';

export function initPage(): void {
	domReady( () => {
		initializePremiumLinks();
		renderHelp();
	} );
}
